/* eslint-disable import/prefer-default-export */

export const USER = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  SOCKET_CONNECTED: 'SOCKET_CONNECTED'
};

export const ROOM = {
  CREATE_ROOM: 'CREATE_ROOM',
  JOIN_ROOM: 'JOIN_ROOM',
  LEAVE_ROOM: 'LEAVE_ROOM'
};
